"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Routes = void 0;
exports.Routes = {
    getTeamsStates: '/auto_dispatch_statistics/state_by_teams/'
};
//# sourceMappingURL=AutoDispatchTeamState.consts.js.map